import {createAction, props} from '@ngrx/store';
import {LoginInput, User} from '@graphql/generated';

export const loadTokenFromLocalStorage = createAction('[Auth] Load Token From Local Storage');
export const setTokenToLocalStorage = createAction('[Auth] Set Token To Local Storage', props<{ token: string, refreshToken: string }>());
export const refreshToken = createAction('[Auth] Refresh Token', props<{ token: string }>());
export const setUserTokenToLocalStorage = createAction('[Auth] Set User Token To Local Storage', props<{ userToken: string, userRefreshToken: string }>());
export const clearImpersonation = createAction('[Auth] Clear Impersonation');
export const setUserInfo = createAction('[Auth] Set User Info', props<{ userInfo: User }>());
export const login = createAction('[Auth] Login', props<{ credentials: LoginInput }>());
export const loginSuccess = createAction('[Auth] Login Success', props<{ token: string; refreshToken: string; user: User }>());
export const loginFailure = createAction('[Auth] Login Failure', props<{ error: string }>());
export const logout = createAction('[Auth] Logout');
export const logoutAdmin = createAction('[Auth] Logout Admin');
export const logoutImpersonatedUser = createAction('[Auth] Logout Impersonated User');
